import React from 'react';
import ContactForm from './ContactForm';
import { MapPin, Phone, Mail } from 'lucide-react';

// Dodanie importu czcionki Inter
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@900&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

const Kontakt = () => {
  return (
    <div className="bg-black text-white">
      {/* Sekcja Hero */}
      {/* ZMIANA: Tło na bg-black, usunięcie gradientu */}
      <section className="relative pt-28 sm:pt-32 pb-16 lg:pb-28 overflow-hidden bg-black">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-violet-600/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-violet-700/20 rounded-full blur-3xl animate-pulse animation-delay-2000"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          {/* ZMIANA: Nagłówek na biały, czcionka Inter 900, uppercase */}
          <h1 
            className="text-3xl sm:text-4xl lg:text-6xl text-white mb-4 uppercase leading-tight"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
          >
            Skontaktuj się z nami
          </h1>
          <p className="text-lg sm:text-xl text-gray-300">
            Jesteśmy do Twojej dyspozycji. Wypełnij formularz lub skorzystaj z danych poniżej.
          </p>
        </div>
      </section>

      {/* Główna sekcja */}
      <section className="py-16 md:py-24 bg-black">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-5 gap-16 items-start">
            
            {/* Lewa, węższa kolumna */}
            <div className="lg:col-span-2 space-y-8">
              <div>
                {/* ZMIANA: Nagłówek h2 - czcionka Inter 900, uppercase */}
                <h2 
                  className="text-3xl text-white mb-6 uppercase"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
                >
                  Dane kontaktowe
                </h2>
                <div className="space-y-4 text-gray-300">
                  <p className="flex items-start gap-4">
                    <MapPin className="w-6 h-6 text-violet-600 mt-1 flex-shrink-0" />
                    <span>
                      <strong className="text-white">Szynkowski & Company</strong><br />
                      Jaśminowa 32A<br />
                      05-092 Łomianki
                    </span>
                  </p>
                  <p className="flex items-center gap-4">
                    <Phone className="w-6 h-6 text-violet-600 flex-shrink-0" />
                    <a href="tel:+48791335232" className="hover:text-white transition-colors">791 335 232</a>
                  </p>
                  <p className="flex items-center gap-4">
                    <Mail className="w-6 h-6 text-violet-600 flex-shrink-0" />
                    <a href="mailto:biuro@szynkowski.com.pl" className="hover:text-white transition-colors">biuro@szynkowski.com.pl</a>
                  </p>
                </div>
              </div>
              <div className="map-container rounded-2xl overflow-hidden border border-white/10">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2438.324397455088!2d20.89033481579983!3d52.34213907978086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb181231089f%3A0x863378b2732994f3!2sJa%C5%9Bminowa%2032a%2C%2005-092%20%C5%81omianki!5e0!3m2!1spl!2spl!4v1678886432123!5m2!1spl!2spl"
                  width="100%" 
                  height="350" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa dojazdu"
                  className="filter grayscale-[80%] hover:grayscale-0 transition-all duration-300"
                ></iframe>
              </div>
            </div>

            {/* Prawa, szersza kolumna */}
            <div className="lg:col-span-3">
              {/* ZMIANA: Nagłówek h2 - czcionka Inter 900, uppercase */}
              <h2 
                className="text-3xl text-white mb-6 uppercase"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
              >
                Napisz do nas
              </h2>
              <ContactForm />
            </div>
            
          </div>
        </div>
      </section>
      
      {/* Dodanie stylów dla animacji, jeśli są potrzebne */}
      <style>{`
        .animation-delay-2000 { animation-delay: 2s; }
      `}</style>
    </div>
  );
};

export default Kontakt;